export const useRestaurantSlug = () => {
    const hostname = window.location.hostname.replace("www.", "");
    // Mantenemos tu lógica de desarrollo local
    return hostname.startsWith("localhost") ? "laesquina" : hostname.split(".")[0];
};